import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-6" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap justify-content-between" }
const _hoisted_4 = { class: "me-5" }
const _hoisted_5 = { class: "me-0 mb-0 text-end" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_8 = { class: "card-body pt-10" }
const _hoisted_9 = { class: "tab-content" }
const _hoisted_10 = {
  class: "tab-pane fade active show",
  id: "tabs_edit_general",
  role: "tabpanel"
}
const _hoisted_11 = { class: "my-5 px-8" }
const _hoisted_12 = { class: "row g-9 mb-8" }
const _hoisted_13 = { class: "col-md-12 fv-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Tiêu đề ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fv-row mt-0" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    id: "kt_modal_new_target_form",
    model: _ctx.objectDetail,
    rules: _ctx.rules,
    ref: "formRef",
    class: "form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.objectDetail.name), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "btn-primary btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit())),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.loading ? "Đang xử lý..." : "Lưu lại"), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_el_form_item, { prop: "name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.convertNameToSlug(_ctx.objectDetail.name))),
                          modelValue: _ctx.objectDetail.name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objectDetail.name) = $event)),
                          placeholder: "Tiêu đề bài viết",
                          name: "name"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "Trạng thái hiển thị" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.objectDetail.status,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objectDetail.status) = $event)),
                          "active-color": "#13ce66",
                          "inactive-color": "#ff4949",
                          "active-value": "active",
                          "inactive-value": "inactive"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_15
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}